module.exports = __webpack_public_path__ + "ca43287764f1125321afa997c50f3303.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-feather-red-s.png
// module id = 2874
// module chunks = 0